<template>
  <v-app-bar color="white" elevation=0>
      <v-btn :href="frontendUrl">
         <v-app-bar-title>
            <img :src="inletsLogo" alt="inlets.ai" class="brand-logo-img" />
         </v-app-bar-title>
      </v-btn>
   </v-app-bar>
   <v-app>
      <v-main>
         <v-container class="fill-height">
            <v-row align="center" justify="center" class="fill-height">
               <v-col cols="12" sm="8" md="6">
                  <v-card class="pa-4">
                     <v-card-title class="text-center pb-6">
                        <h3 style="font-family: 'Poppins', sans-serif;">Reset your password</h3>
                     </v-card-title>
                     <v-card-text>
                        <v-form v-model="isFormValid">
                           <v-text-field
                              v-model="newPassword1"
                              color="primary"
                              label="Password"
                              variant="outlined"
                              :rules="passwordRules"
                              prepend-inner-icon="mdi-email-outline"
                           ></v-text-field>
                           <v-text-field
                              v-model="newPassword2"
                              color="primary"
                              label="Verify Password"
                              variant="outlined"
                              :rules="[passwordRules, passwordConfirmationRule]"
                              prepend-inner-icon="mdi-email-outline"
                           ></v-text-field>
                        </v-form>
                        <p class="pl-2" style="color: red">{{ resetError }}</p>
                     </v-card-text>
                     <v-card-actions class="pa-6">
                        <v-row>
                           <span>
                              <v-btn :disabled="!isFormValid" @click="setNewPassword" color="primary">Reset Password</v-btn>
                           </span>
                        </v-row>
                     </v-card-actions>
                  </v-card>
               </v-col>
            </v-row>
       </v-container>
     </v-main>
   </v-app>
 </template>
 
 <script>
 import { mapActions, mapGetters } from "vuex";
 import router from "@/router";
 import inletsLogo from "@/assets/images/inlets-logo-color.svg";

 export default {
   name: 'Login',
   computed: {
      ...mapGetters(["getAuthToken", "getUserEmail", "getUserID", "isLoggedIn"]),
      frontendUrl() {
         return process.env.VUE_APP_FRONTEND_URL
      },
      passwordConfirmationRule() {
         return () => (this.newPassword1 === this.newPassword2) || 'Password must match'
      },
      resetError() {
         return this.$store.state.auth.reset_error
      }
    },
   data() {
        return {
            inletsLogo,
            isFormValid: false,
            newPassword1: "",
            newPassword2: "",
            passwordRules: [
               v => !!v || "Password is required",
               v => (v && v.length >= 8) || "Password must be at least 8 characters",
            ],
        };
    },
   methods: {
      ...mapActions(["resetPassword"]),
      async setNewPassword(event) {
         this.$store.state.auth.reset_error = "";
         event.preventDefault();
         let data = {
               token: this.$route.query.token,
               password: this.newPassword1,
         };
         await this.resetPassword(data);
         this.toLogin();
      },
      toLogin() {
         router.push({ name: 'Login' });
      }
   }
 }
 </script>
 <style scoped>
 .forgot-password {
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    text-align: center;
    color: #65647C;
    text-decoration: none;
 }
 </style>
 